'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/performers.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect} from "react";
import Loading from "./loading";
import { formatEventDate } from '@/app/utils/formatDate';
import CodeDisplay from "@/app/utils/content";
import CaroeuslOffer from "@/app/components/offer-carousel";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData(slug) {
  const query = `
{
  pageData: qlperformerBy(uri: "${slug}") {
    performers {
      performerCountry
      performerDescription
      playingClub
      upcomingPerformance {
        performanceDate
        performanceTime
      }
      performerDetailDescription
      performerPoints
      fbInner
      instaInner
    }
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
    title
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );
  const { data } = await res.json();

  return data;
}

export default async function PerformersInner({ params }) {

   const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);
  
  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [performIner_title, setPerformInnerTitle] = useState("");
  const [performerCountry, setcountry] = useState("");
  const [performerclub, setplayingClub] = useState("");
  const [performerdateTime, setAllUpcomingPeform] = useState([]);
  const [performPoints, setperformerPoints] = useState("");
  const [performDetails, setperformerDetailDescription] = useState("");
  const [fbInner,setfbInner] = useState("");
  const [instaInner, setinstaInner] = useState("");

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  const formatEventDate = (dateString) => {
    if (!dateString) return { day: "", month: "", year: "" }; // Handle empty or invalid date
  
    const dateObj = new Date(dateString);
  
    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
      return { day: "Invalid", month: "Invalid", year: "Invalid" };
    }
  
    // Extract day, month, and year
    const day = dateObj.getDate(); // Day of the month (1-31)
    const month = dateObj.toLocaleString("en-US", { month: "long" }); // Month name (e.g., January)
    const year = dateObj.getFullYear(); // Full year (e.g., 2024)
  
    return { day, month, year };
  };


  useEffect(() => {
    async function fetchData() {
      if (params.slug) {
        const query = `/sin-performer/${params.slug}/`;
        const page = await getPageData(query);
        if(page){
           // console.log(page);
            if(page.pageData){
                setPageData(page.pageData);

              if(page.pageData.title){
                if(page.pageData.title){
                  setPerformInnerTitle(page.pageData.title);
                }
              }

              if(page.pageData.pageBan){
                if(page.pageData.pageBan.bannerText){
                  setPageBannerText(page.pageData.pageBan.bannerText);
                }
                if(page.pageData.pageBan.bannerSlider){
                  setPageBannerSliders(page.pageData.pageBan.bannerSlider);
                }
              }

              if(page.performers){
                if(page.performers.nodes){
                  setPerformers(page.performers.nodes);
                }
              }

              if (page?.pageData?.performers) {
                if (page.pageData.performers.performerCountry) {
                  setcountry(page.pageData.performers.performerCountry);
                }
                if (page.pageData.performers.playingClub) {
                  setplayingClub(page.pageData.performers.playingClub);
                }
                if (page.pageData.performers.upcomingPerformance) {
                  setAllUpcomingPeform(page.pageData.performers.upcomingPerformance);
                }
                if (page.pageData.performers.performerPoints) {
                  setperformerPoints(page.pageData.performers.performerPoints);
                }
                if (page.pageData.performers.performerDetailDescription) {
                  setperformerDetailDescription(page.pageData.performers.performerDetailDescription);
                }
                if (page.pageData.performers.fbInner) {
                  setfbInner(page.pageData.performers.fbInner) ;
                }
                if (page.pageData.performers.instaInner) {
                  setinstaInner (page.pageData.performers.instaInner);
                }
              }
              
            }
            setPreLoaderEnable(false);
          }
      }
    }
    fetchData();
    return () => {};
  }, [params.slug]);

  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();


          const formatEventDate = (dateString) => {
            if (!dateString) return { day: "", month: "", year: "" }; // Handle empty or invalid date
          
            const dateObj = new Date(dateString);
          
            // Check if the date is valid
            if (isNaN(dateObj.getTime())) {
              return { day: "Invalid", month: "Invalid", year: "Invalid" };
            }
          
            // Extract day, month, and year
            const day = dateObj.getDate(); // Day of the month (1-31)
            const month = dateObj.toLocaleString("en-US", { month: "long" }); // Month name (e.g., January)
            const year = dateObj.getFullYear(); // Full year (e.g., 2024)
          
            return { day, month, year };
          };
         

      }


    )()
  }, [])



  if (pre_loader_enabled) {
    return <Loading />;
  }


  return (
    <>
{/* <div className="position-relative">
      
</div>
       */}

<section className="inner-banner position-relative PerformInerBner sinInerPerform">
        {page_banner_sliders && page_banner_sliders.length !== 0 &&(
        <CaroeuslOffer page_banner_sliders={page_banner_sliders}/>
        )}
      </section>
      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-green green-mesh  inner-banner position-relative PerformInerBner">
        <div className="placeholderImageBanner"><Image src="https://d4hfzongcfd8o.cloudfront.net/2024/09/aloneB.png" width={1920} height={1080}></Image></div>
        <div className='inner-banner-text z-top'>
          <h2 className='all-caps section-heading-large section-heading--yellow m-0'>{page_banner_text}</h2>
        </div>
      </section>
      )}
  
      <section className={`${styles.performSection} position-absolute section-padding-bottom section-padding-top`}>
          <div className={`${styles.wrapPerform}`}>              
              <div className={styles.bannerInerWrap}>
                <h1 className="section-heading section-heading--white heading-padding all-caps">{performIner_title}</h1>
                {performerCountry && (
                  <h3 className={styles.performerCountry}>{performerCountry}</h3>
                )}                
                <div><hr className={styles.hrLine}></hr></div>
                {performerclub && (
                  <div className={styles.playClub}>Playing Club : {performerclub}</div>
                )}                
                <div className={styles.upcoming}>upcoming performances</div>
                <div className={`${styles.upcomingDates} d-flex`}>
                {performerdateTime.length > 0 ? (
                    performerdateTime.map((allupcomers, index) => {
                      const performDate = allupcomers.performanceDate || "";
                      const performTime = allupcomers.performanceTime || "";

                      // Get separate day, month, and year
                      const { day, month, year } = formatEventDate(performDate);


                        return (
                          <div className={styles.dateUpcoming} key={index}>
                            <div className={`d-flex ${styles.dateUpcomingP}`}>
                              <h2 className={`d-flex flex-wrap ${styles.datep}`}>
                                <span className={styles.day}>{performDate}</span> 
                              </h2>
                              <p className={styles.timep}>{performTime}</p>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <p>No upcoming performances available.</p>
                    )}
                </div>
              </div>
          </div>
      </section>

      <section className={`${styles.InnerMainSec} section-padding-bottom section-padding-top bg-dark-meroon green-mesh`}>
          <div className="middle-wrap">
            <div className={`d-flex ${styles.wrapInerMain}`}>
                <div className={styles.leftinerwrap}> 
                    <div className={styles.pointsPerform}>
                      <CodeDisplay code={performPoints}/>
                    </div>
                    <div className={styles.socialicons}>
                      <h4 className={styles.mediaText}>find on social media </h4>
                      <div className={`d-flex ${styles.iconSM}`}>
                        {fbInner && (
                          <Link target="_blank" href={fbInner}>
                            <Image src="/fb.png" width={50} height={50} alt="Facebook Icon" />
                          </Link>
                        )}
                          {instaInner && (
                            <Link target="_blank" href={instaInner}>
                            <Image
                              src="/insta.png"
                              width={50}
                              height={50}
                              alt="Instagram Icon"
                            />
                          </Link>
                          )}
                          
                      </div>
                    </div>
                </div>
                <div>
                  <hr className={styles.pInerLine}></hr>
                </div>
                <div className={styles.rightInerWrap}>
                  <CodeDisplay code={performDetails}/>
                </div>
            </div>
          </div>       
      </section>

    </>
  )
}
